export enum CatalogStatus {
  CATALOGED = "등록됨",
  NOT_CATALOGED = "등록안됨",
}
